import React, { ChangeEvent } from 'react';
import styled from 'styled-components';

type CheckboxFieldComponentProps = {
  id: string
  className?: string
  label: string
  name?: string
  placeholder?: string
  mb?: string
  checked?: boolean,
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  required?: boolean
}

const CheckboxStyle = styled.div<{$mb?: string}>`
  color: #383432;
  text-align: left;
  box-sizing: border-box;
  padding: 0 0 0 30px;
  position: relative;
  width: auto;
  margin-bottom: ${props => props.$mb || '0'};

  input {
    display: none;

    &:checked + label::after {
      opacity: 1;
    }
  }

  label {
    padding-left: 10px;
    cursor: pointer;

    &::before {
      background: #fff;
      border: 1px solid #726c69;
      content: '';
      display: block;
      height: 16px;
      left: 5px;
      margin-top: -8px;
      position: absolute;
      top: 50%;
      width: 16px;
    }

    &::after {
      border-right: 3px solid #383432;
      border-bottom: 3px solid #383432;
      content: '';
      display: block;
      height: 9px;
      left: 10px;
      margin-top: -7px;
      opacity: 0;
      position: absolute;
      top: 50%;
      transform: rotate(45deg);
      width: 5px;
    }
  }
`;

const CheckboxField: React.FC<CheckboxFieldComponentProps> = ({ id, className, label, name, placeholder, checked, mb, onChange, required }) => {
  return (
    <CheckboxStyle className={className} $mb={mb}>
      <input type='checkbox' id={id} name={name} placeholder={placeholder} checked={checked} onChange={onChange} required={required} />
      <label htmlFor={id}>{ label }</label>
    </CheckboxStyle>
  );
};

export default CheckboxField;
